import React from 'react';
import {ConfigApi, PlaceApi} from "../../../../../../../services/Api/types";
import {useTranslation} from "react-i18next";
import {ReactComponent as CutleryIco} from "../../../../../../../../images/icons/cutlery.svg";
import AppConfig from "../../../../../../../services/AppConfig";
import IframeWidget from "../../../../../../../utils/IframeWidget";
import classNames from "classnames";

interface Props {
    config: ConfigApi;
    places: PlaceApi[];
}

const MultistoreBrandListHero = ({config, places}: Props) => {
    const cover = config.layout.cover_large ?? "/images/test/cover.jpg";
    const backgroundImage = config.layout.cover_large;
    const {t} = useTranslation();

    const scrollToPlacesSection = () => {
        const placesSection = document.getElementById("places");

        if (!placesSection) return;

        const navbarHeight = document.getElementById("main-navbar")?.clientHeight ?? 0;
        const scrollToOptions: ScrollToOptions = {
            top: placesSection.offsetTop - navbarHeight,
            behavior: "smooth"
        };

        if (AppConfig.isWidget()) {
            IframeWidget.scrollTo(scrollToOptions);
        } else {
            window.scrollTo(scrollToOptions);
        }
    };

    const buildHeroBackground = (image?: string) => {
        const gradient = AppConfig.isDarkMode() ?
            ` linear-gradient(180deg, rgba(31, 41, 58, 0.25) 0%, #1F293A 45%)`
            : `linear-gradient(180deg, rgba(241, 245, 249, 0.25) 0%, #F1F5F9 45%)`;
        return image ? `${gradient}, url("${image}")` : gradient;
    };

    return (
        <div className="multistore-brand-list-hero">
            <div
                className={classNames('multistore-brand-list-hero-bg', {
                    'multistore-brand-list-hero-bg-image': !!backgroundImage
                })}
                style={{backgroundImage: buildHeroBackground(backgroundImage)}}
            />
            <div className="hero-content">
                <div className="big-image-container" style={{backgroundImage: `url("${cover}")`}}/>
                {config.description && (
                    <p className="mb-0 description">{config.description}</p>
                )}
                {places.length > 0 && (
                    <div className="d-grid gap-2 d-md-block align-self-center buttons-container">
                        <button className="btn btn-lg btn-primary check-offer-btn" onClick={scrollToPlacesSection}>
                            <CutleryIco className="me-2"/>
                            {t("modules.multistore.action.check_our_offer.title")}
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}

export default MultistoreBrandListHero;